import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-debito-automatico-warning-modal',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './debito-automatico-warning-modal.component.html',
  styleUrls: ['./debito-automatico-warning-modal.component.css'],
})
export class DebitoAutomaticoWarningModalComponent {
  readonly mensaje =
    'El cambio de responsable de pago desactiva el débito automático actual. Podrá activarlo nuevamente con el nuevo responsable si así lo desea.';

  constructor(
    private dialogRef: MatDialogRef<DebitoAutomaticoWarningModalComponent>
  ) {}

  cerrar(): void {
    this.dialogRef.close();
  }
}
